import { Link } from 'react-router';
import styled, { css } from 'styled-components';

import { ExternalLink } from 'components/external-link';

const sharedStyles = css`
  text-decoration: none;
  overflow: hidden;
  height: inherit;

  ${Styles.desktop} {
    transition: all 0.2s;
  }
`;

const sharedListStyles = css`
  text-decoration: none;
  overflow: hidden;
  height: inherit;
  border-block-end: 1px solid ${Styles.color.grey.four};

  ${Styles.desktop} {
    border-block-end: none;
    transition: all 0.2s;
  }
`;

export const TileLink = styled(Link)<{ $transparent: boolean }>`
  ${sharedStyles}
`;

export const TileLinkExternal = styled(ExternalLink)`
  ${sharedStyles}
`;

export const TileListLink = styled(Link)<{ $transparent: boolean }>`
  ${sharedListStyles}
`;

export const TileListLinkExternal = styled(ExternalLink)`
  ${sharedListStyles}
`;
